
export class RoleGroupUserModel {
  roleGroupIds: string[];
  userId: string;
}
